import React, { useEffect, useRef, useState } from 'react';
import "./ProposalPreparation.css";

const TYPING_INTERVAL = 3;

const ResponseLogger = ({ log, delayAfterLog = 2000 }) => {
  const [typedMessage, setTypedMessage] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [parsedJSON, setParsedJSON] = useState(null);
  const [visibleRowCount, setVisibleRowCount] = useState(0);
  const sectionKeys = {"work_package_title": "İş Paketi Adı", "start_month": "Başlangıç Ayı", "duration": "Süre (Ay)", 
                       "title": "Başlık", "citation": "Referans", "year": "Yıl", "abstract": "Özet"};

  const currentLogRef = useRef(null);
  const timeoutRef = useRef(null);
  const typingIndexRef = useRef(0);
  const loggerRef = useRef(null);

  //work_package_title	start_month	duration
  //title	doi	citation	citation_count	citation_rate	similarity_score	year	abstract

  const formatTextWithNewlines = (text) => {
    if (!text) return '';

    
    // First decode escape sequences like \n and \t into real characters
    const decoded = text
      .replace(/\\n/g, '\n')
      .replace(/\\t/g, '\t');

    // Then convert to HTML-safe format
    return decoded
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\n/g, "<br/>")
      .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
  };

  useEffect(() => {
    if (!log?.message || log.message === currentLogRef.current) return;
    

    // If the text is surrounded with quotes, remove them
    if (log.message.startsWith('"') && log.message.endsWith('"')) {
      log.message = log.message.slice(1, -1);
    }

    clearTimeout(timeoutRef.current);
    currentLogRef.current = log.message;

    const message = log.message.trim();
    typingIndexRef.current = -1;
    setTypedMessage("");
    setParsedJSON(null);
    setIsTyping(true);

    let parsed = null;
    let isProbablyJSON = false;

    try {
      parsed = JSON.parse(message);

      // If it's a string, it may be double-encoded JSON
      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }

      if (typeof parsed === 'object') {
        isProbablyJSON = true;
      }
    } catch {
      // Not JSON
    }

    if (isProbablyJSON && parsed) {
      try{
        if (Array.isArray(parsed)) {
          setParsedJSON(parsed);
          setVisibleRowCount(0);

          const revealRow = (index) => {
            if (index >= parsed.length) {
              setIsTyping(false);
              return;
            }
            setVisibleRowCount(index + 1);
            setTimeout(() => revealRow(index + 1), 1000); 
          };

          revealRow(0); // Start revealing from the first row
          return;
        } else {
          setParsedJSON([parsed]); // Wrap object
          setVisibleRowCount(1);
          setIsTyping(false);
          return;
        }
      }catch {
      // Not JSON
    }
    } 

    const typeNextChar = () => {
      if (typingIndexRef.current < message.length) {
        setTypedMessage(prev => prev + message.charAt(typingIndexRef.current));
        typingIndexRef.current += 1;
        timeoutRef.current = setTimeout(typeNextChar, TYPING_INTERVAL);
      } else {
        timeoutRef.current = setTimeout(() => {
          setIsTyping(false);
        }, delayAfterLog);
      }
    };

    typeNextChar();

    return () => clearTimeout(timeoutRef.current);
  }, [log, delayAfterLog]);

  useEffect(() => {
    if (loggerRef.current) {
      loggerRef.current.scrollTop = loggerRef.current.scrollHeight;
    }
  }, [typedMessage, parsedJSON]);

  const renderJSONTable = (data) => {
    if (!Array.isArray(data)) return <div>JSON format desteklenmiyor.</div>;
    if (data.length === 0) return <div>Boş JSON verisi</div>;

    const excludedKeys = new Set([
      "doi",
      "citation_count",
      "citation_rate",
      "similarity_score",
      "abstract"
    ]);

    const headers = Object.keys(data[0]).filter(key => !excludedKeys.has(key));

    return (
      <table className="json-table">
        <thead>
          <tr>
            {headers.map((key) => (
              <th key={key}>{sectionKeys[key]}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.slice(0, visibleRowCount).map((row, idx) => (
            <tr key={idx}>
              {headers.map((key) => (
                <td key={key}>{row[key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };


  return (
  <div className="logger-window" ref={loggerRef}>
    {parsedJSON ? (
      <div className="logger-message">{renderJSONTable(parsedJSON)}</div>
    ) : (
      <div
        className="logger-message"
        dangerouslySetInnerHTML={{
          __html: formatTextWithNewlines(typedMessage || "ProWA - ProWA Yapay Zeka Ajanı Hazırlanıyor...")
        }}
      />
    )}
  </div>
  );
};

export default ResponseLogger;
